/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Have_AccountInputs */

const en_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const es_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

const fr_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà un compte ?`)
};

const de_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits ein Konto?`)
};

const ja_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちですか？`)
};

const zh_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已经有账号了？`)
};

const ar_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لديك حساب بالفعل؟`)
};

const id_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah punya akun?`)
};

const it_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account?`)
};

const ru_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже есть аккаунт?`)
};

const pt_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem uma conta?`)
};

const ko_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 계정이 있으신가요?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_have_account = /** @type {((inputs?: Auth_Have_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Have_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_have_account(inputs)
	if (locale === "es") return es_auth_have_account(inputs)
	if (locale === "fr") return fr_auth_have_account(inputs)
	if (locale === "de") return de_auth_have_account(inputs)
	if (locale === "ja") return ja_auth_have_account(inputs)
	if (locale === "zh") return zh_auth_have_account(inputs)
	if (locale === "ar") return ar_auth_have_account(inputs)
	if (locale === "id") return id_auth_have_account(inputs)
	if (locale === "it") return it_auth_have_account(inputs)
	if (locale === "ru") return ru_auth_have_account(inputs)
	if (locale === "pt") return pt_auth_have_account(inputs)
	return ko_auth_have_account(inputs)
});